import { RequestParams } from "@core/services/http/http.type";
import { Meta } from "./common.type";

export const RequestParamsDashboardType = {
  PURCHASED: 1,
  VIEWED: 2,
} as const;

export type RequestParamsDashboardType =
  (typeof RequestParamsDashboardType)[keyof typeof RequestParamsDashboardType];

export interface RequestParamsDashboard extends RequestParams {
  voucherCode?: string;
  startDate?: string;
  endDate?: string;
  userType?: string[];
  sortBy?: string;
  bookIds?: (number | string)[];
  bookId?: number;
  authorId?: number;
  type?: RequestParamsDashboardType;
}

export interface ResponseVoucherActiveInteraction<T> {
  data: {
    items: T[];
    meta: Meta;
    totalListener: number;
  };
  status: string;
}

export interface VoucherActiveInteraction {
  bookId: number;
  bookName: string;
  bookThumbnail: string;
  viewCount: number;
  listenCount: number;
  totalTime: number;
}

export interface ResponseVoucherActiveUses<T> {
  data: {
    items: T[];
    totalUser: number;
  };
  status: string;
}

export interface VoucherActiveUses {
  date: string;
  userCount: number;
}

export interface GeneralInformationItem {
  value: number;
  lable: string;
}

export interface GeneralInformation {
  totalBook: number;
  totalUser: number;
  totalUserPurchase: number;
  totalUserNew: number;
  totalAuthor: number;
  infoUsers: GeneralInformationItem[];
  infoBooks: GeneralInformationItem[];
  infoRevenues: GeneralInformationItem[];
}

export enum PaymentInformationLabel {
  APPLE_STORE = "Apple store",
  CH_PLAY = "Google console",
  BANK = "Bank",
}

export interface PaymentInformation {
  totalMoney: number;
  items: {
    value: number;
    label: PaymentInformationLabel;
  }[];
}

export interface BookRevenue {
  totalMoneyAuthor: number | null;
  totalMoneyAllTime?: number | null;
  items: {
    bookId: number;
    thumbnails: string[];
    bookName: string;
    money: number;
    moneyAllTime?: number | null;
    authorName: string;
    listens: number | null;
    listensAllTime?: number | null;
    purchases: number | null;
  }[];
  meta: Meta;
}

export interface AuthorRevenue {
  items: {
    authorId: number;
    name: string;
    thumbnails: string;
    retailRevenue: number;
    vipRevenue: number;
    vipEstimatedRevenue: number;
    vipRevenueAllTime: number;
    retailRevenueAllTime: number;
    withdrawableRevenue: number;
    revenue: number;
    paidAmount: number;
    remainAmount: number;
  }[];
  meta: Meta;
}

export interface BookPurchase {
  totalList: number;
  items: {
    fullName: string;
    thumbnailUser: string;
    bookId: number;
    bookName: string;
    thumbnailBook: string[];
    createDate: string;
    priceBook: number | null;
    viewCount: number | null;
    likeCount: number | null;
    shareCount: number | null;
    listenCount: number | null;
    commentCount: number | null;
    timeUserListenLabel: string;
    timeAudioBookLabel: string;
  }[];
  meta: Meta;
}

export interface BookInteraction {
  items: {
    totalView: number;
    totalLike: number;
    totalComment: number;
    totalShare: number;
    totalListen: number;
    label: string;
  }[];
}
